(function(){
  document.addEventListener('DOMContentLoaded', function() {

  /*
  * ajax product recomendations to cart
  */
  window.addRelatedProductToCart = function (id) {
    let cartRelated = document.querySelector('.drawer__footer product-recommendations');
    if (!cartRelated) return false;

    
    const currentUrl = window.location.origin;
    let relatedUrl = currentUrl + cartRelated.dataset.url;
    const urlObj = new URL(relatedUrl);
    urlObj.searchParams.set('product_id', id);
    // urlObj.searchParams.set('section_id', 'template--17474741207198__related_products_swiper_qCT7cU');


    relatedUrl = urlObj.toString();

    fetch(relatedUrl)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');
        const $this = document.querySelector('.drawer__footer .related-products');
        if (recommendations && recommendations.innerHTML.trim().length) {
          $this.innerHTML = recommendations.innerHTML;
          document.querySelector('product-recommendations .related-products__heading').textContent = 'את המוצרים האלה כבר ניסית?';
        }

        if ( html.querySelector('.grid__item') ) {
          $this.classList.add('product-recommendations--loaded');
          // let recomendationBlock = document.querySelector(recommendations);
        }

      })
      .catch((e) => {
        console.error(e);
      });
    }

    let lastAddedProduct = document.querySelector('.cart-items [data-product-id]')?.getAttribute('data-product-id');
    if ( lastAddedProduct ) {
      window.addRelatedProductToCart(lastAddedProduct);
    }
    
  }, false);
})();